import React, { useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import ResourcesTable from './ResourcesTable';
import MyStudySidekick from '../../common/MyStudySidekick';
import { GenerateResourceButton } from './GenerateResourceButton';
import { RESOURCE_TYPES } from '../helpers/resourceTypes';
import { ALL_RESOURCES_TAB } from '../../common/constants';

export const DesktopResourceBrowser = ({ id }) => {
  const [activeTab, setActiveTab] = useState(ALL_RESOURCES_TAB);
  const activeResourceType = RESOURCE_TYPES.find((type) => type.id === activeTab);

  return (
    <>
      <Box className="dashboardSection" id={`${id}__topSection`}>
        <Box className="header" id={`${id}__header`}>
          <img
            src="/img/StudySidekickMascot.svg"
            alt="myStudySidekick mascot"
            className="mascot"
            id={`${id}__mascot`}
          />
          <Box>
            <MyStudySidekick component="h1" className="title" id={`${id}__title`} />
            <Typography className="description" id={`${id}__description`}>
              Welcome to myStudySidekick- a tool that assesses student progress and creates
              personalized learning tools adapted to individual needs. On-demand, 24/7
              individualized support, powered by student data and course expectations.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box className="dashboardTabsRow">
        <Tabs
          className="dashboardTabs"
          value={activeTab}
          onChange={(_e, nextTab) => setActiveTab(nextTab)}
          aria-label="Resource type"
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab value={ALL_RESOURCES_TAB} label="All Resources" id={`${id}__tab_all`} />
          {RESOURCE_TYPES.map(({ id: typeId, pluralLabel }) => (
            <Tab key={typeId} value={typeId} label={pluralLabel} id={`${id}__tab_${typeId}`} />
          ))}
        </Tabs>
        <GenerateResourceButton id={id} activeTab={activeTab} />
      </Box>

      <Box className="dashboardTables" id={`${id}__tables`}>
        {activeTab === ALL_RESOURCES_TAB ? (
          RESOURCE_TYPES.map((resourceType) => (
            <Box
              className="dashboardSection"
              key={resourceType.id}
              id={`${id}__section_${resourceType.id}`}
            >
              <ResourcesTable id={`${id}__${resourceType.id}`} resourceType={resourceType} />
            </Box>
          ))
        ) : (
          <Box className="dashboardSection" id={`${id}__section_${activeTab}`}>
            <ResourcesTable
              key={activeTab}
              id={`${id}__${activeTab}`}
              resourceType={activeResourceType}
            />
          </Box>
        )}
      </Box>
    </>
  );
};
